export default {
  state: {
    academyData: {},
    academyLegals: {}
  },

  getters: {
    getAcademyData (state) {
      return state.academyData
    },

    getAcademyLegals (state) {
      return state.academyLegals
    }
  },

  mutations: {
    setAcademyData (state, academyData) {
      state.academyData = academyData
    },

    setAcademyLegals (state, academyLegals) {
      state.academyLegals = academyLegals
    },

    unsetAcademyData (state) {
      state.academyData = {}
    },

    unsetAcademyLegals (state) {
      state.academyLegals = {}
    }
  }
}
